// src/msalConfig.js
import { PublicClientApplication, LogLevel } from "@azure/msal-browser";
import { config } from "./config";

// Log the environment variables to debug (these will show in console)
console.log("🔧 MSAL Config - Frontend Client ID:", config.frontendClientId);
console.log("🔧 MSAL Config - Tenant ID:", config.tenantId);
console.log("🔧 MSAL Config - Redirect URI:", window.location.origin);

const b2cTenantId = config.tenantId; // e.g., "contosob2c"
const b2cUserFlowName = config.b2cUserFlowName; // e.g., "B2C_1_TechManagerSignUp"
const b2cClientId = config.frontendClientId; // The ID you copied from App registrations
const tenantName = config.b2cTenantName; // e.g., "contosob2c"
const redirectUri = window.APP_CONFIG?.REDIRECT_URI || window.location.origin; // || "http://localhost:3001";//window.location.origin; // Ensure this matches what you set in Azure
console.log("REdirect URl", redirectUri);
export const msalConfig = {
  auth: {
    clientId: b2cClientId,
    authority: `https://${tenantName}.ciamlogin.com/${b2cTenantId}`,
    knownAuthorities: [`https://${tenantName}.ciamlogin.com`],
    redirectUri: redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        console.log(message);
      },
      logLevel: LogLevel.Verbose, // Using LogLevel here
      piiLoggingEnabled: false,
    },
  },
};

// Login request scopes – used in RegistrationForm
export const loginRequest = {
  scopes: ["openid", "profile"],
  prompt: "login" 
};

// MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);